<template>
  <div class="bread" v-if="breadList.length>0">
    <el-breadcrumb separator=">">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item,index) in breadList" :key="index">{{item}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
import { mapState} from 'vuex'
export default {
  name: '',
  data(){
    return {
    }
  },
  components:{
  },
  computed: {
    ...mapState({
      breadList:state => state.breadList
    })
  },
  methods: {
    
  },
 
  mounted() {
  }
}
</script>
<style lang='less' scoped>
.bread{
  width: 1200px;
  margin: 0 auto;
  height: 54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #D5DAE1;
}

</style>